import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';

dayjs.extend(localizedFormat);
dayjs.extend(utc);

const parseDate = (value) => {
  const date = dayjs.utc(value);

  // avoid treating a year typo like “197” as the year AD 197
  if (date.year() < 1900) return;

  return date;
};

export const formatDate = (value) => {
  if (value === undefined) return '';

  const date = parseDate(value);

  return date.isValid() ? date.format('L') : '';
};

export const formatDateTime = (value) => {
  if (value === undefined) return '';

  const date = parseDate(value);

  // 'L LT' gives localized date and time (e.g., 06/07/2024 3:30 PM)
  return date.isValid() ? date.format('L LT') : '';
};

export const formatDateISO = (value) => {
  const date = parseDate(value);

  return date.isValid() ? date.format('YYYY-MM-DD') : '';
};
